import { useRef, useState, useEffect, useMemo } from 'react';
import { profiles } from '../../../mocks/profiles';

export default function GirlsSection() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const shuffledProfiles = useMemo(() => {
    return [...profiles].sort(() => Math.random() - 0.5);
  }, []);

  const handleScroll = () => {
    if (scrollRef.current) {
      const scrollLeft = scrollRef.current.scrollLeft;
      const itemWidth = scrollRef.current.offsetWidth * 0.75;
      const index = Math.round(scrollLeft / itemWidth);
      setCurrentIndex(index);
    }
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (el) {
      el.addEventListener('scroll', handleScroll);
      return () => el.removeEventListener('scroll', handleScroll);
    }
  }, []);

  return (
    <section id="girls" className="py-10 px-4 bg-white">
      <div className="max-w-md mx-auto">
        <div className="text-center mb-6">
          <span className="inline-block bg-pink-50 text-pink-500 text-xs font-bold px-4 py-1.5 rounded-full mb-3">
            GIRLS
          </span>
          <h2 className="text-xl font-bold text-gray-800 mb-2">
            注目の女の子
          </h2>
          <p className="text-gray-500 text-xs leading-relaxed">
            人気の女の子をチェックしよう
          </p>
        </div>

        <div
          ref={scrollRef}
          className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-3 pb-4"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {shuffledProfiles.map((profile) => (
            <div key={profile.id} className="flex-shrink-0 w-[75%] snap-center">
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-100">
                <div className="relative w-full h-72">
                  <img
                    src={profile.image}
                    alt={profile.name}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute top-2.5 right-2.5 bg-white/90 backdrop-blur-sm px-2.5 py-1 rounded-full flex items-center gap-1">
                    <i className="ri-star-fill text-amber-400 text-xs"></i>
                    <span className="font-bold text-gray-800 text-xs">{profile.rating}</span>
                  </div>
                  <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/50 to-transparent h-20"></div>
                  <div className="absolute bottom-2.5 left-3">
                    <p className="text-white font-bold text-base">{profile.name}</p>
                    <p className="text-white/80 text-xs">{profile.age}歳</p>
                  </div>
                </div>

                <div className="p-4">
                  <p className="text-gray-600 text-xs mb-3 leading-relaxed">
                    {profile.description}
                  </p>
                  <div className="flex flex-wrap gap-1.5 mb-3">
                    {profile.tags.map((tag, i) => (
                      <span
                        key={i}
                        className="bg-rose-50 text-rose-500 px-2.5 py-0.5 rounded-full text-[10px] font-medium"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <a
                    href="https://cl1-ck.com/rida_00app_lovenavi04kyara.html"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="block w-full text-center text-white py-2.5 rounded-full font-medium text-xs shadow-md whitespace-nowrap cursor-pointer transition-opacity hover:opacity-90"
                    style={{ backgroundColor: '#06C755' }}
                  >
                    <i className="ri-user-add-line mr-1"></i>
                    友達追加
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center gap-1.5 mt-3">
          {shuffledProfiles.map((_, index) => (
            <div
              key={index}
              className={`h-1.5 rounded-full transition-all ${
                index === currentIndex ? 'w-6 bg-rose-500' : 'w-1.5 bg-gray-300'
              }`}
            ></div>
          ))}
        </div>
      </div>
    </section>
  );
}
